var Services = angular.module('RessieApp.services', [
    // 'RessieApp.services.mocks'
  , 'RessieApp.services.api'
]);